import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

// @ts-expect-error - Automatic, Please fix when editing this file
const NextRedirect = ({ to }) => {
  const router = useRouter();

  useEffect(() => {
    router.push(to);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

type RedirectAdapterProps = {
  to: string;
};

const RedirectAdapter = ({ to }: RedirectAdapterProps) => <NextRedirect to={to} />;

export default RedirectAdapter;
